function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "delivery/stockpiling");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M431,215 C431,333.741105 334.741357,430 216.000563,430 C97.2586427,430 1,333.741105 1,215 C1,96.2588947 97.2586427,2.27373675e-13 216.000563,2.27373675e-13 C334.741357,2.27373675e-13 431,96.2588947 431,215",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "delivery/stockpiling",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(94.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-4",
  fill: "#172737",
  fillRule: "nonzero",
  opacity: 0.200000003,
  transform: "translate(191.369565, 430.559184) rotate(1.000000) translate(-191.369565, -430.559184) ",
  cx: 191.369565,
  cy: 430.559184,
  rx: 190.369565,
  ry: 3.55918367
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Fill-1",
  fill: "#B9D5E0",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-3",
  mask: "url(#mask-2)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.000000, 196.000000)",
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 0,
  y: 0,
  width: 252.689266,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#C6B25D",
  x: 252.689266,
  y: 0,
  width: 175.310734,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#F2E7B7",
  x: 0,
  y: 0,
  width: 252.689266,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 252.689266,
  y: 0,
  width: 175.310734,
  height: 3
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-2",
  mask: "url(#mask-2)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.000000, 256.000000)",
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 0,
  y: 0,
  width: 252.591429,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#C6B25D",
  x: 247.757143,
  y: 0,
  width: 175.242857,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#F2E7B7",
  x: 0,
  y: 0,
  width: 252.591429,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 247.757143,
  y: 0,
  width: 175.242857,
  height: 3
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy",
  mask: "url(#mask-2)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 316.000000)",
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 0,
  y: 0,
  width: 252.813031,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#C6B25D",
  x: 251.603399,
  y: 0,
  width: 175.396601,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#F2E7B7",
  x: 0,
  y: 0,
  width: 252.813031,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 251.603399,
  y: 0,
  width: 175.396601,
  height: 3
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  mask: "url(#mask-2)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.813211, 376.000000)",
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 0,
  y: 0,
  width: 252.980395,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#C6B25D",
  x: 248.138665,
  y: 0,
  width: 175.512714,
  height: 60
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#F2E7B7",
  x: 0,
  y: 0,
  width: 252.980395,
  height: 3.05084746
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E0CE80",
  x: 248.138665,
  y: 0,
  width: 175.512714,
  height: 3.05084746
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(326.976878, 216.236614)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 38.9252207,
  cy: 11.1614648,
  rx: 15.3024453,
  ry: 10.8321389
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 15.6014784,
  cy: 11.1614648,
  rx: 15.3024453,
  ry: 10.8321389
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.2453621,4.26837133 C29.5050096,6.11581796 30.8677388,8.50644989 30.8677388,11.1175738 C30.8677388,13.7286978 29.5050096,16.1193297 27.2453621,17.9667764 C24.9855046,16.1193297 23.6227754,13.7286978 23.6227754,11.1175738 C23.6227754,8.5247816 24.9664374,6.14939628 27.1976925,4.30736222 Z",
  id: "Combined-Shape",
  fill: "#00693C"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(320.000000, 277.000000)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 38.6124198,
  cy: 11.3606817,
  rx: 15.1794757,
  ry: 11.0254778
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 15.4761058,
  cy: 11.3606817,
  rx: 15.1794757,
  ry: 11.0254778
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.0269774,4.34502366 C29.2681331,6.22538046 30.6196874,8.65849879 30.6196874,11.3160074 C30.6196874,13.9735161 29.2681331,16.4066344 27.0269774,18.2869912 C24.7844984,16.4066344 23.4329441,13.9735161 23.4329441,11.3160074 C23.4329441,8.67693736 24.7658085,6.25915464 26.9791333,4.38424278 Z",
  id: "Combined-Shape",
  fill: "#00693C"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy-2",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(316.976878, 333.328501)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 38.9252207,
  cy: 11.1614648,
  rx: 15.3024453,
  ry: 10.8321389
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 15.6014784,
  cy: 11.1614648,
  rx: 15.3024453,
  ry: 10.8321389
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.2453621,4.26837133 C29.5050096,6.11581796 30.8677388,8.50644989 30.8677388,11.1175738 C30.8677388,13.7286978 29.5050096,16.1193297 27.2453621,17.9667764 C24.9855046,16.1193297 23.6227754,13.7286978 23.6227754,11.1175738 C23.6227754,8.5247816 24.9664374,6.14939628 27.1976925,4.30736222 Z",
  id: "Combined-Shape",
  fill: "#00693C"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy-2",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(313.976878, 393.928688)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 38.9252207,
  cy: 11.1614648,
  rx: 15.3024453,
  ry: 10.8321389
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 15.6014784,
  cy: 11.1614648,
  rx: 15.3024453,
  ry: 10.8321389
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.2453621,4.26837133 C29.5050096,6.11581796 30.8677388,8.50644989 30.8677388,11.1175738 C30.8677388,13.7286978 29.5050096,16.1193297 27.2453621,17.9667764 C24.9855046,16.1193297 23.6227754,13.7286978 23.6227754,11.1175738 C23.6227754,8.5247816 24.9664374,6.14939628 27.1976925,4.30736222 Z",
  id: "Combined-Shape",
  fill: "#00693C"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(88.000000, 214.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E0CE80",
  x: 0,
  y: 0,
  width: 186.083333,
  height: 309
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(23.625000, 159.605469)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 0.375,
  y: 0.39453125,
  width: 90,
  height: 120
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#CCCCCC",
  x: 13.375,
  y: 34.3945312,
  width: 8,
  height: 71,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "#CCCCCC",
  x: 31.375,
  y: 62.3945312,
  width: 8,
  height: 43,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#CCCCCC",
  x: 67.375,
  y: 62.3945312,
  width: 8,
  height: 43,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "#CCCCCC",
  x: 49.375,
  y: 51.3945312,
  width: 8,
  height: 54,
  rx: 3
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C6B25D",
  x: 186.083333,
  y: 0,
  width: 45.9166667,
  height: 309
})));

var SvgStockpiling = function SvgStockpiling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "620px",
    viewBox: "0 0 620 620",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStockpiling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stockpiling.9850c5e3.svg";
export { ForwardRef as ReactComponent };